import gql from 'graphql-tag';

export const FRAGMENT_VARIATION_COMPLIANCE = gql`
  fragment VariationCompliance on Variation {
    id
    complianceStatus
    complianceProgressPercentage
    complianceError {
      type
      message
    }
  }
`;

export const FRAGMENT_LONG_FORM_DRAFT_COMPLIANCE = gql`
  fragment LongFormDraftCompliance on LongFormBuilderDraft {
    id
    complianceStatus
    complianceProgressPercentage
    complianceError {
      type
      message
    }
  }
`;

export const FRAGMENT_BLOG_DRAFT_COMPLIANCE = gql`
  fragment BlogDraftCompliance on BlogPostBuilderDraft {
    id
    complianceStatus
    complianceProgressPercentage
    complianceError {
      type
      message
    }
  }
`;
